import { useEffect, useState } from 'react'
import { connect } from "react-redux"
import { Box } from '@mui/system'
import { Tab, Tabs } from '@mui/material'

import { i18nStatsTabs } from './i18n'
import { useTranslate } from '../../../hooks/translate'
import { IncomesGraphic } from './graphics/IncomesGraphic'
import { TabPanel } from '../../../components/TabPanel/TabPanel'
import { getAllUsers } from '../../../data/actions/usersActions'
import { OrdersCountGraphic } from './graphics/OrdersCountGraphic'
import { HourOfOrderGraphic } from './graphics/HourOfOrderGraphic'
import { RegisteredUsersGraphic } from './graphics/RegisteredUsersGraphic'
import { getAllCompletedOrders } from "../../../data/actions/ordersActions"
import { OrdersDestinationTotalGraphic } from './graphics/OrdersDestinationTotalGraphic'
import { OrdersDestinationOvertimeGraphic } from './graphics/OrdersDestinationOvertimeGraphic'
import { getCompletedInternalSchedules } from '../../../data/actions/internalSchedulesActions'
import { getCompletedCrossBorderSchedules } from '../../../data/actions/crossBorderSchedulesActions'
import { OrdersWeightsGraphic } from './graphics/OrdersWeightGraphic'

const StatsTabs = {
    REGISTERED_USERS: 0,
    ORDERS_COUNT: 1,
    ORDERS_WEIGHTS: 2,
    INCOMES: 3,
    DESTINATIONS_TOTAL: 4,
    DESTINATIONS_OVERTIME: 5,
    HOUR_OF_ORDER: 6,
}

function StatisticsSectorComponent(props: any) {
    const [tab, setTab] = useState(StatsTabs.REGISTERED_USERS)

    const t = useTranslate(i18nStatsTabs)

    const handleChange = (ev: any, value: any) => setTab(value)

    useEffect(() => {
        props.getAllUsers()
        props.getAllCompletedOrders()
        props.getCompletedInternalSchedules()
        props.getCompletedCrossBorderSchedules()
    }, [props])

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChange}>
                    <Tab label={t.registeredUsers} id="statistics-tab-0" />
                    <Tab label={t.ordersCount} id="statistics-tab-1" />
                    <Tab label={t.ordersWeights} id="statistics-tab-2" />
                    <Tab label={t.incomes} id="statistics-tab-3" />
                    <Tab label={t.destinationTotal} id="statistics-tab-4" />
                    <Tab label={t.destinationOvertime} id="statistics-tab-5" />
                    <Tab label={t.hourOfOrder} id="statistics-tab-6" />
                </Tabs>
            </Box>
            <TabPanel value={tab} index={StatsTabs.REGISTERED_USERS}>
                <RegisteredUsersGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.ORDERS_COUNT}>
                <OrdersCountGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.ORDERS_WEIGHTS}>
                <OrdersWeightsGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.INCOMES}>
                <IncomesGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.DESTINATIONS_TOTAL}>
                <OrdersDestinationTotalGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.DESTINATIONS_OVERTIME}>
                <OrdersDestinationOvertimeGraphic />
            </TabPanel>
            <TabPanel value={tab} index={StatsTabs.HOUR_OF_ORDER}>
                <HourOfOrderGraphic />
            </TabPanel>
        </>
    )
}

const mapDispatchToProps = {
    getAllUsers,
    getAllCompletedOrders,
    getCompletedInternalSchedules,
    getCompletedCrossBorderSchedules
}

export const StatisticsSector = connect(null, mapDispatchToProps)(StatisticsSectorComponent)
